<template>
    <el-select v-model="values" placeholder="请选择" @change="change" clearable style="width: 100%;">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
    name: "ZdSelect",
    data(){
        return{
            list:[
                {name:'直采',id:'zhicai'},
                {name:'代理',id:'daili'},
            ],
            values:''
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        value:{
            type:String,
            default:''
        }
    },
    created() {
        this.values = this.value ? this.value : '';
    },
    watch:{
        value(n,o){
            this.values = n ? n : '';
        }
    },
    mounted() {

    },
    methods:{
        change(e){
            this.$emit("change", e);
        }
    }
}
</script>
